import { getMessagesBySrcTxHash } from "@layerzerolabs/scan-client";
import { toast } from "react-toastify";

const POLL_INTERVAL = 10000;
const MAX_POLLS = 60;

const MESSAGES = {
  deposit: {
    submitted: "Your USDC is on its way to Nibiru! This usually takes 1-3 minutes.",
    confirming: "Transaction confirmed. LayerZero is picking it up...",
    inflight: "Almost there — delivering your USDC to Nibiru. Hang tight!",
    delivered: "Done! Your USDC has arrived on Nibiru and is ready to trade.",
    failed: "Something went wrong delivering your USDC. Your funds are safe — please try again or check LayerZero Scan.",
    timeout: "Your deposit is taking longer than usual but is still processing. You can safely close this — your funds will arrive.",
  },
  withdraw: {
    submitted: "Your withdrawal is being processed! This usually takes 1-3 minutes.",
    confirming: "Transaction confirmed. LayerZero is picking it up...",
    inflight: "Almost there — delivering your USDC to the destination. Hang tight!",
    delivered: "Done! Your USDC has arrived and is ready to use.",
    failed: "Something went wrong delivering your USDC. Your funds are safe — please try again or check LayerZero Scan.",
    timeout: "Your withdrawal is taking longer than usual but is still processing. You can safely close this — your funds will arrive.",
  },
};

/**
 * Track a LayerZero bridge transaction until delivered or failed.
 * Shows ONE persistent loading toast throughout. Only shows success/error
 * toast when funds actually arrive or fail.
 */
export function trackBridgeStatus(srcEid, txHash, direction, onDelivered) {
  const msgs = MESSAGES[direction];

  // Single loading toast — stays until terminal state
  const toastId = toast.loading(msgs.submitted, {
    autoClose: false,
    closeOnClick: false,
    closeButton: false,
  });

  let polls = 0;
  let lastText = msgs.submitted;

  const updateText = (text) => {
    if (text === lastText) return;
    lastText = text;
    toast.update(toastId, { render: text });
  };

  const poll = async () => {
    polls++;

    if (polls > MAX_POLLS) {
      toast.dismiss(toastId);
      toast.warn(msgs.timeout, { autoClose: 15000 });
      return;
    }

    try {
      const result = await getMessagesBySrcTxHash(srcEid, txHash);
      const msg = result?.messages?.[0];

      if (!msg) {
        if (polls >= 3) updateText(msgs.confirming);
        setTimeout(poll, POLL_INTERVAL);
        return;
      }

      switch (msg.status) {
        case "DELIVERED":
          toast.dismiss(toastId);
          toast.success(msgs.delivered, { autoClose: 10000 });
          if (onDelivered) onDelivered();
          return;

        case "FAILED":
          toast.dismiss(toastId);
          toast.error(msgs.failed, { autoClose: 12000 });
          return;

        case "INFLIGHT":
          updateText(msgs.inflight);
          setTimeout(poll, POLL_INTERVAL);
          return;

        default:
          updateText(msgs.confirming);
          setTimeout(poll, POLL_INTERVAL);
          return;
      }
    } catch {
      setTimeout(poll, POLL_INTERVAL);
    }
  };

  setTimeout(poll, 5000);
}
